import { stripHtmlTags } from "./utils";

/**
 * Formats an entity display name as `entity «title»`, falling back to `unknownFallback`
 * when `title` is absent.
 */
export function formatEntityName(entityName: string, title: string): string {
  title = stripHtmlTags(title || "");
  return `${entityName} «${title}»`;
}

/**
 * Replaces the `{EntityName}` placeholder in a translation template string.
 */
export function replaceEntityName(template: string, entityName: string): string {
  return template.replace("{EntityName}", entityName);
}
